import { render, staticRenderFns } from "./QuotaBuyRefunds.vue?vue&type=template&id=b5f75472"
import script from "./QuotaBuyRefunds.vue?vue&type=script&lang=js"
export * from "./QuotaBuyRefunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports